// extracted by extract-css-chunks-webpack-plugin
module.exports = {"item":"item_3oVS9","item__link":"item__link_EJc0I"};